import { useState } from "react";
import { ArrowRight, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { postNewsletter } from "@/lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await postNewsletter(email);
      toast.success("¡Suscrito! Bienvenido a Fuelkers.");
      setEmail("");
    } catch {
      toast.error("Email inválido");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="site-footer" className="relative border-t border-white/5 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <div className="mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_automotive-boost-3/artifacts/8ujqnsw0_LOGO-FUELKERS.png"
                alt="Fuelkers"
                className="h-24 w-auto object-contain"
                style={{filter:'brightness(0) invert(1) drop-shadow(0 0 22px rgba(255,255,255,0.25))'}}
              />
            </div>
            <p className="text-white/55 max-w-sm leading-relaxed font-body italic">
              &ldquo;Donde otros frenan, tú aceleras.&rdquo;
            </p>
            <p className="mt-3 text-white/45 max-w-sm leading-relaxed font-body text-sm">
              Ecosistema de crecimiento para negocios del motor. Captación, contenido y marca bajo un mismo techo.
            </p>
            <form onSubmit={submit} className="mt-8 flex gap-2 max-w-md">
              <Input
                data-testid="newsletter-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@email.com"
                type="email"
                className="bg-black/40 border-white/15 text-white h-12 rounded-xl"
              />
              <Button data-testid="newsletter-submit" type="submit" disabled={loading} className="h-12 px-5 bg-[#FFD700] hover:bg-[#FFE34D] text-black rounded-none font-stencil">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <ArrowRight className="w-4 h-4" strokeWidth={3} />}
              </Button>
            </form>
            <p className="text-xs text-white/35 mt-3">Newsletter semanal. Tácticas accionables para negocios del motor.</p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <FooterCol
              title="Secciones"
              items={[
                { label: "Problema", href: "#problema" },
                { label: "Comparativa", href: "#comparativa" },
                { label: "Sistema", href: "#sistema" },
                { label: "Resultados", href: "#resultados" },
                { label: "Calculadora", href: "#calculadora" },
              ]}
            />
            <FooterCol
              title="Servicios"
              items={[
                { label: "Captación", href: "#sistema" },
                { label: "Contenido multicanal", href: "#sistema" },
                { label: "Marca & Posicionamiento", href: "#sistema" },
                { label: "Automatización", href: "#sistema" },
              ]}
            />
            <FooterCol
              title="Contacto"
              items={[
                { label: "Reservar llamada", href: "#contacto" },
                { label: "fuelkersagency@gmail.com", href: "mailto:fuelkersagency@gmail.com" },
                { label: "+34 664 45 68 52", href: "tel:+34664456852" },
              ]}
            />
          </div>
        </div>

        <div className="pt-10 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-white/40">
          <span>© 2026 FUELKERS. Todos los derechos reservados.</span>
          <span>Hecho en España · Ecosistema de crecimiento para negocios del motor.</span>
        </div>

        <div className="mt-12 select-none overflow-hidden">
          <div className="font-stencil leading-none text-transparent tracking-tighter text-center" style={{WebkitTextStroke:'2px rgba(0,160,160,0.18)', fontSize:'clamp(48px, 15vw, 220px)'}}>
            FUELKERS
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-widest text-white/40 mb-4">{title}</div>
      <ul className="space-y-3">
        {items.map((i) => (
          <li key={i.label}>
            <a href={i.href} className="text-sm text-white/75 hover:text-white transition-colors">{i.label}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}
